import React from 'react';


function Layout(props) {
  return (
    <React.Fragment>
      <header>
        <div className='logo'></div>
      </header>

      <main>
        {props.children}
      </main>

      <footer>
      </footer>
    </React.Fragment>
  );
}
export default Layout;